

function HeadLogo() {
  function backToHomeACB() {
    window.location.hash = "#/mapOverview";
  }

  return (
    <div className="global-headlogo" onClick={backToHomeACB}>
      stad.hunt
    </div>
  );
}

export { HeadLogo };

